import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SharedService {

  constructor(private http: HttpClient) { }

  // Api to share content
  shareContent(contentInfo): Observable<any> {
    return this.http.post(`common/sendShareList`, contentInfo);
  }

}
